<template>
  <div
    class="container fullscreen-layout"
    :style="bgStyle"
  >

    <!-- <div
      class="m-main-content"
      :style="imageStyle"
      v-if="info.cImgType==='0'"
    >
      <div class="form-wrapper">
        <slot></slot>
      </div>
    </div> -->
    <div class="notice-wrapper" v-if="!isChrome"><el-alert title="推荐使用chrome浏览器" type="info" simple show-icon></el-alert></div>
    <div
      class="system-info"
      :class="{'is-notify':isNotify}"
      v-if="info.identifyType === '0'"
    >
      <img
        class="logo"
        :src="logoPath"
        v-if="info.loginLogoInfo"
        :style="iconImgStyle"
      >
     <div class="title-wrapper">
      <span
        class="title"
        :style="systemNameStyle"
      >{{info.systemName}}</span>
      <span
        class="sub-title"
        :style="systemNameStyle"
        v-if="info.systemSubtitle"
      >{{info.systemSubtitle}}</span>
     </div>
      <div
        class="select-wrapper"
        :class="{'is-notify':isNotify}"
      >
        <el-button
          type="iconButton"
          icon="h-icon-download"
          class="down-btn"
          :style="downloadTextColor"
          @click="openDownLoad"
        >
          {{$t('login.download_text')}}
        </el-button>
        <slot
          name="lang-select"
        ></slot>
      </div>
    </div>
    <div class="system-info" v-else>
      <img
        class="logo"
        :src="info.identifyImgInfo.path"
        :style="identifyImgInfoStyle"
      >
    </div>
    <div
      class="m-main-content"
    >
      <!-- <lottie
        :options="defaultOptions"
        :dateTime="dateTime"
      ></lottie> -->
      <div class="form-wrapper" :style="wrapperStyle">
        <slot></slot>
      </div>
    </div>
    <!-- <div
      class="select-wrapper"
      :class="{'is-notify':isNotify}"
    >
      <el-button
        type="iconButton"
        icon="h-icon-download"
        class="down-btn"
        :style="downloadTextColor"
        @click="openDownLoad"
      >
        {{$t('login.download_text')}}
      </el-button>
      <slot
        name="lang-select"
      ></slot>
    </div> -->
    <div class="version-info-wrapper">
      <version-info></version-info>
    </div>
    <div class="qrcode-info-wrapper" v-show="platId">
      <div class="shortcut-info"></div>
      <div class="detail-info">
        <canvas
          id="platId-qrcode"
          class="platId-qrcode"
        ></canvas>
        <div class="tip">进入公司考勤登录页</div>
      </div>
    </div>
  </div>
</template>

<script>
import versionInfo from './version-info.vue'
import lottie from 'components/lottie/lottie'
import axios from 'axios'
import QRCode from 'qrcode'
export default {
  name: 'fullscreen-layout',
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          backgroundImgInfo: {
            path: ''
          },
          bgColor: '',
          bgImgType: '1',
          cImgType: '0',
          ctImgInfo: {
            path: ''
          },
          ctZipInfo: {
            path: ''
          },
          identifyImgInfo:{
            path: ''
          },
          identifyType:'0',
        }
      }
    },
    isNotify: {
      type: Boolean,
      default: false
    },
    platId:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      defaultOptions: {},
      dateTime: new Date().getTime(),
      screenHeight: 0,
    }
  },
  created() {
    this.screenHeight = window.innerHeight
    console.log(this.screenHeight)
    this.setScreenHeight = () => {
      console.log('resize')
      this.screenHeight = window.innerHeight
    }
    // this.setScreenHeight = this.$lodash.debounce(() => {
    //   console.log('resize')
    //   this.screenHeight = window.innerHeight
    // }, 300)
    window.addEventListener('resize', this.setScreenHeight)
  },
  beforeDestroy() {
    window.addEventListener('resize', this.setScreenHeight)
  },
  computed: {
    downloadTextColor () {
      return {
        'color': 'rgba(0,0,0,0.7)'
      }
    },
    bgStyle () {
      let _res = {}
      if (this.info.bgImgType === '0') {
        _res['background-image'] = `url(${this.info.backgroundImgInfo.path})`
        _res['background-size'] = 'cover'
      } else {
        _res['background-color'] = this.info.bgColor
      }
      if(!this.info.recordNumber){
        _res['height'] = '100%'
      }
      return _res
    },
    wrapperStyle() {
      let _res = {}
      let margin = this.screenHeight * 0.3 - 84
      if (margin < 0) {
        margin = 0
      }
      _res['margin-top'] = margin + 'px'
      return _res
    },
    systemNameStyle () {
      return {
        // 'color': `${this.info.systemNameColor || '#fff'}`
        'color': `${'#000'}`
      }
    },
    imageStyle () {
      if (this.info.ctImgInfo) {
        return {
          'background-image': `url(${this.info.ctImgInfo.path})`
        }
      }
      return {}
    },
    iconImgStyle () {
      const _iconImg = this.info.loginLogoInfo
      if (!_iconImg) return {}
      const _height = parseInt(_iconImg.height) < 38 ? _iconImg.height : 38
      return {
        height: `${_height}px`
      }
    },
    identifyImgInfoStyle(){
      const _identifyImgInfo = this.info.identifyImgInfo.path
      if (!_identifyImgInfo) return {}
      const _height = parseInt(_identifyImgInfo.height) < 61 ? _identifyImgInfo.height : 60
      return {
        height: `${_height}px`
      }
    },
    logoPath () {
      return this.info.loginLogoInfo ? this.info.loginLogoInfo.path : ''
    },
    isChrome() {
      return window.navigator.userAgent.indexOf("Chrome") !== -1;
    }
  },
  methods: {
    openDownLoad () {
      this.$emit('open-download')
    },
    async getAnimatJson () {
      if (this.info.ctZipId !== '-1' && this.info.cImgType && this.info.ctZipInfo) {
        const requestUrl = this.info.ctZipInfo.path
        const animatJson = await axios.get(requestUrl)
        for (let i = 0; i < animatJson.data.assets.length; i++) {
          if (animatJson.data.assets[i].u) {
            animatJson.data.assets[i].u = `${process.env.VUE_APP_BASEURL}/zip/dynamicDisplay/${this.info.ctZipId}/images/`
          } else {
            break
          }
        }
        this.dateTime = new Date().getTime()
        this.defaultOptions = { animationData: animatJson.data }
      }
    },
    setScreenHeight() {
      return this.$loadash.debounce(() => {
        console.log('resize')
        this.screenHeight = window.innerHeight
      }, 300)
    }
  },
  components: {
    versionInfo,
    lottie
  },
  watch: {
    info: {
      handler () {
        this.getAnimatJson()
      },
      deep: true
    },
    platId (value) {
      if(value){
        let canvas = document.getElementById('platId-qrcode')
        QRCode.toCanvas(canvas, `${value},eaas`, {
          width: 86,
          height: 86,
          margin: 0
        })
      }

    }
  },
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.fullscreen-layout.container {
  width: 100%;
  height: 100%;
  // height: calc(~"100% - 30px");
  position: relative;
  display: flex;
  flex-direction: column;
  background-size: contain;
  // background-image: url(~@/assets/images/bg2.png);

  .copyright-wrapper {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    height: 16px;
    .name {
      text-decoration: none;
      display: inline-block;
      vertical-align: middle;
    }
    .logo {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .content-wrapper {
    position: absolute;
    width: 1200px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    font-size: 0;
    .bgimg-wrapper {
      width: 792px;
      height: 630px;
      display: inline-block;
      margin-right: 80px;
      vertical-align: middle;
      .inner {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
    .form-wrapper {
      width: 400px;
      // padding-bottom: 20px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 34px;
    }
  }
  .version-info-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  .notice-wrapper{
    position: absolute;
    top: 0;
    width: 100%;
    position: absolute;
    left: 0;
    z-index: 100;
    /deep/.el-alert {
      display: flex;
      .el-alert__content{
        display: flex;
        align-items: center;
      }
    }
  }
  .qrcode-info-wrapper{
    position: absolute;
    bottom: 0;
    right: 0;
    .shortcut-info {
      width: 42px;
      height: 46px;
      background: url("../../assets/images/Code.png");
      transform: rotate(-90deg);
    }
    .detail-info {
      // position: absolute;
      // right: 0;
      // bottom: 0;
      width: 140px;
      // margin-bottom: 1px;
      // margin-left: 1px;
      display: none;
      text-align: center;
      overflow: hidden;
      background: #fff;
      padding: 8px 0px;
      .platId-qrcode {
        width: 86px;
        height: 86px;
        margin: 16px auto 2px;
      }
      .tip{
        font-size:16px;
      }
    }
    &:hover {
      .shortcut-info {
        display: none;
      }
      .detail-info {
        display: block;
      }
    }
  }
  .system-info {
    min-height: 38px;
    padding: 46px 56px 0 66px;
    position: relative;
    display: flex;
    align-items: center;
    z-index: 9;
    .title-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        font-size: 18px;
        line-height: 22px;
        font-weight: bold;
        height: 22px;
        color: #fff;
        white-space: pre;
      }
      .sub-title {
        font-size: 12px;
        line-height: 14px;
        height: 14px;
        color: #fff;
        white-space: pre;
      }
    }
    .logo {
      margin-right: 6px;
      display: inline-block;
      vertical-align: middle;
      width: auto;
    }
    .select-wrapper {
      position: absolute;
      top: 52px;
      right: 56px;
      display:flex;
      align-content: center;
      .down-btn {
        vertical-align: middle;
        font-weight: normal;
        background: none;
        // opacity: 0.6;
        font-weight: 600;
        border: 1px solid rgba(255,255,255,0.12);
        border-radius: 2px;
        z-index: 10;
        filter: alpha(opacity=60);
        &:hover {
          background: none;
          opacity: 1;
          filter: alpha(opacity=100);
        }
      }
    }
    .select-wrapper.is-notify {
      top: 56px;
    }
  }
  .system-info.is-notify {
    top: 56px;
  }
  .m-main-content {
    flex: 1;
    position: relative;
    width: 100%;
    // background-image: url("../../assets/images/fff.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center right;
    // background-image: url(~@/assets/images/content.png);
    background-size: contain;
    .form-wrapper {
      position: relative;
      width: 400px;
      padding-left: 15%;
      z-index: 1;
      // transition: all .5s;
      // background: #fff;

    }
  }
}
</style>
